import axios from 'axios';
import React from 'react';
import './index.css';
import authHeader from '../../services/auth-header';
import {config, LOG_OUT} from '../../constants';
import AuthService from '../../services/auth.service';
import i18n from 'i18next';
import {Button, Cascader, Input, message, Select} from 'antd';
import {EditOutlined} from '@ant-design/icons';


export default class AddOrUpdateTestComponent extends React.Component {

    constructor(props) {
        super(props);

        const testID = this.props.match.params.testID
        const pageMode = testID ? "update" : "add";

        this.state = {
            pageMode: pageMode,
            testID: testID,
            test:{
                name:"",
                staticTests: [],
                settings: {},
                resultTests: []
            },
            staticTestTypes: ["page_up_check", "login", "logout"]
        }

        if (this.state.pageMode == "update") {
            axios.get(config.API_URL + "tests/" + this.state.testID, {headers: authHeader()}).then(response => {
                
                const testToBeUpdated = response.data

                this.setState({test: testToBeUpdated})

            })
        }

    }

    addTest = () => {

        let test = this.state.test
        let updatedTest = Object.assign({}, test);


        let resultTests = test.resultTests
        let updatedResultTests = [];

        for(let i = 0; i<resultTests.length; i++){
          let item = resultTests[i];

          let updatedCheckList = {} 

          Object.keys(item.checkList).map(key =>{
            let newList = {}
            let checklist = item.checkList[key];
            let listName = checklist["name"]
            delete checklist["name"]
            Object.keys(checklist).map(key => {
              let pair = checklist[key]
              if(pair[0] != "NewField"){
                newList[pair[0]] = pair[1]
              }
            })
            updatedCheckList[listName] = newList;
          })
          item.checkList = updatedCheckList;
          updatedResultTests.push(item)
        }
        updatedTest.resultTests = updatedResultTests;
      
        const testModel = {
          name: updatedTest.name,
          test: JSON.stringify({
            settings: updatedTest.settings,
            resultTests: updatedTest.resultTests,
            staticTests: updatedTest.staticTests
          }),
          active: true
        }
        
        AuthService.addTest(testModel).then(
            response => {
                let success = response.data;

                if (success) {

                  console.log(success)
                    
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)
                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )        
            
    }

    updateTest = () => {
        const {nameEn, nameTr, shortNameEn, shortNameTr, flag} = this.state.test;

        let name =  {"translations":{"en": nameEn, "tr": nameTr}};
        let shortName = {"translations":{"en": shortNameEn, "tr": shortNameTr}};

        const test = {name, shortName, flag};

        AuthService.updateTest(test, this.state.testID).then(
            response => {
                let success = response.data;
                if (success) {

                    axios.get(config.API_URL + "api-cache-clear/cacheOfSanctionListsUi", {headers: authHeader()}).then(
                        response => {
                            let success = response.data;

                            if (success){
                                window.location = "/test-controller";
                            }
                            else {
                                message.error(i18n.t('global_error'));
                            }
                        }
                    )
                } else {
                    message.error(i18n.t('global_error'));
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )
    }


    handleInputChange = (e, inputType, index, subIndex, subSubIndex) => {
  const { name, value } = e.target;

  if (inputType === "setting") {
    this.setState(prevState => ({
      test: {
        ...prevState.test,
        settings: {...prevState.test.settings, [name]:value}
      }
    }));
    
  }
  if (inputType === "otherState") {
    this.setState(prevState => ({
      test: {
        ...prevState.test,
        [name]:value
      }
    }));
  }
  else if (inputType === "person") {
    this.setState(prevState => {
      const updatedResultTests = [...prevState.test.resultTests];
      updatedResultTests[index] = { ...updatedResultTests[index], [name]: value };

      return {
        test: {
          ...prevState.test,
          resultTests: updatedResultTests
        }
      };
    });
  } else if (inputType === "list") {

    this.setState(prevState => {
      const updatedResultTests = [...prevState.test.resultTests];
      const updatedCheckList = { ...updatedResultTests[index].checkList };

      updatedCheckList[subIndex] = { ...updatedCheckList[subIndex], name: value };

      updatedResultTests[index] = { ...updatedResultTests[index], checkList: updatedCheckList };

      return {
        test: {
          ...prevState.test,
          resultTests: updatedResultTests
        }
      };
    });
  } else if (inputType === "result") {
    this.setState(prevState => {
      const updatedResultTests = [...prevState.test.resultTests];
      const updatedCheckList = [...updatedResultTests[index].checkList];
      const updatedResult = { ...updatedCheckList[subIndex][subSubIndex], [name]: value };

      updatedCheckList[subIndex][subSubIndex] = updatedResult;
      updatedResultTests[index] = { ...updatedResultTests[index], checkList: updatedCheckList };

      return {
        test: {
          ...prevState.test,
          resultTests: updatedResultTests
        }
      };
    });
  }
};

      
      
    handleRolesChange = (tests) => {

        this.setState(prevState => ({
            test: {
                ...prevState.test,
                staticTests: tests
            }
        }))

    }

    addPerson = () => {
        this.setState(prevState => ({
          test: {
            ...prevState.test,
            resultTests: [
              ...prevState.test.resultTests,
              { name: "", expectedResultCount: "", checkList:{}}
            ]
          }
        }));
      }
      
      addResultControl = (personIndex) => {
        this.setState(prevState => {
          const updatedResultTests = [...prevState.test.resultTests];
          const updatedCheckList = { ...updatedResultTests[personIndex].checkList };
          const newListKey = `list${Object.keys(updatedCheckList).length + 1}`;
          updatedCheckList[newListKey] = {};
      
          updatedResultTests[personIndex].checkList = updatedCheckList;
      
          return {
            test: {
              ...prevState.test,
              resultTests: updatedResultTests
            }
          };
        });
      };
      
      addNewField = (personIndex, listIndex) => {
        this.setState(prevState => {
          const updatedResultTests = [...prevState.test.resultTests];
          const checkList = updatedResultTests[personIndex].checkList;
          const listName = Object.keys(checkList)[listIndex];
          const newList = { ...checkList[listName] };
          
          newList[Object.keys(newList).length-1] = ["NewField", ""]

          checkList[listName] = newList;
      
          return {
            test: {
              ...prevState.test,
              resultTests: updatedResultTests
            }
          };
        });
      };
      
      handleResultFieldInputChange = (event, personIndex, listIndex, resultIndex) => {
        const { name, value } = event.target;
        
        this.setState(prevState => {
          const updatedResultTests = prevState.test.resultTests.map((person, pIndex) => {
            if (pIndex === personIndex) {
              const updatedCheckList = { ...person.checkList };
              const listName = Object.keys(updatedCheckList)[listIndex];
              const updatedResult = { ...updatedCheckList[listName][resultIndex] };

              updatedCheckList[listName][resultIndex][1] = value;

              return {
                ...person,
                checkList: updatedCheckList
              };
            }
            return person;
          });
      
          return {
            test: {
              ...prevState.test,
              resultTests: updatedResultTests
            }
          };
        });
      };

      handleCascaderChange = (value, personIndex, listIndex, index) => {

        this.setState(prevState => {
          const updatedResultTests = [...prevState.test.resultTests];
          const checkList = updatedResultTests[personIndex].checkList;
          const listName = Object.keys(checkList)[listIndex];

          checkList[listName][index] = [value[0], ""]; 
            
          return {
            test: {
              ...prevState.test,
              resultTests: updatedResultTests
            }
          };
        });
      };
      
    render() {

        const options = [
            {
              value: 'Name Surname',
              label: 'Name Surname',
            },
            {
              value: 'Place of Birth',
              label: 'Place of Birth',
            },
            {
                value: 'Date of Birth',
                label: 'Date of Birth',
            },
            {
                value: 'Citizenship',
                label: 'Citizenship',
            },
            {
                value: 'Nationality',
                label: 'Nationality',
            },
            {
                value: 'AKAs',
                label: 'AKAs',
            },
            {
                value: 'Other Info',
                label: 'Other Info',
            },
            {
                value: 'Identification Details',
                label: 'Identification Details',
            },
            {
                value: 'Addresses',
                label: 'Addresses',
            },
          ];

        var resultTests = this.state.test.resultTests.map((test, personIndex) => (
            <React.Fragment key={test.id}>
              <hr className='custom-hr'/>
              <h3 style={{textAlign:"center"}}>{test.name || "New Person"}</h3>
              <br/>
              <div className='form-box-user-input'>
                <Input
                  type="text"
                  value={test.name}
                  name="name"
                  placeholder={i18n.t('test_person_name')}
                  autoComplete="off"
                  prefix={<EditOutlined/>}
                  onInput={(e) => this.handleInputChange(e, "person", personIndex)}
                />
              </div>
              <div className='form-box-user-input'>
                <Input
                  type="text"
                  value={test.expectedResultCount}
                  name="expectedResultCount"
                  placeholder={i18n.t('test_person_expectedResultCount')}
                  autoComplete="off"
                  prefix={<EditOutlined/>}
                  onInput={(e) => this.handleInputChange(e, "person", personIndex)}
                />
              </div>
              {Object.keys(test.checkList).map((key, listIndex) => {
                const item = test.checkList[key];
                
                return (
                  <React.Fragment key={key}>
                    <hr className='custom-hr'/>
                    <h3 style={{textAlign:"center"}}>{item.name || "New List"}</h3>
                    <br/>

                    <Input
                      key={key}
                      type="text"
                      value={item.name}
                      name={`list_name_${personIndex}_${key}`}
                      placeholder={i18n.t('test_person_list_name')}
                      autoComplete="off"
                      prefix={<EditOutlined />}
                      onInput={(e) => this.handleInputChange(e, "list", personIndex, key)}
                    />
                    
                    {
                    Object.keys(item).slice(0, Object.keys(item).length - 1).map((key, resultIndex) =>{
                        return(
                        <Input
                        addonBefore={
                            <Cascader
                            placeholder="Key"
                            style={{ width: 140, height: "100%" }}
                            options={options}
                            name={key}
                            defaultValue={[key]}
                            onChange={(value) => this.handleCascaderChange(value, personIndex, listIndex, resultIndex)}
                            />
                        }
                        style={{ width: "100%" }}
                        onChange={(value) => this.handleResultFieldInputChange(value, personIndex, listIndex, resultIndex)}/>
                        )
                    })
                    }

                    <Button
                      className="custom-button"
                      type="button"
                      onClick={() => this.addNewField(personIndex, listIndex)}
                    >
                      New Field
                    </Button>
                  </React.Fragment>
                );
              })}
              <Button
                className="custom-button"
                type="button"
                onClick={() => this.addResultControl(personIndex)}
              >
                Add Result Test
              </Button>
            </React.Fragment>
          ));
          

        return (

            <>
                <section className="user-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center mr-0 ml-0">
                            <div className="form-box-user custom-ant-input-wrapper">
                                <div>
                                <form method="POST" action="">
                                {this.state.pageMode === "update" ? (
                                    <>
                                    <h3 style={{textAlign:"center"}}>Test: {this.state.test.name}</h3>
                                    <br/>
                                    </>
                                ) : (
                                    <>
                                    <h3 style={{textAlign:"center"}}>Test Name</h3>
                                    <br/>
                                    </>
                                )}
                                <div className='form-box-user-input'>
                                    <Input
                                    type="text"
                                    value={this.state.test.name}
                                    name="name"
                                    placeholder={i18n.t('test_input_name')}
                                    autoComplete="off"
                                    prefix={<EditOutlined/>}
                                    onInput={(e) => this.handleInputChange(e, "otherState")}
                                    />
                                </div>
                                <h3 style={{textAlign:"center"}}>Test Settings</h3>
                                <br/>
                                <div className='form-box-user-input'>
                                    <Input
                                    type="text"
                                    value={this.state.test.settings.url}
                                    name="url"
                                    placeholder={i18n.t('test_url')}
                                    autoComplete="off"
                                    prefix={<EditOutlined/>}
                                    onInput={(e) => this.handleInputChange(e, "setting")}
                                    />
                                </div>
                                <div className='form-box-user-input'>
                                    <Input
                                    type="text"
                                    value={this.state.test.settings.email}
                                    name="email"
                                    placeholder={i18n.t('test_input_email')}
                                    autoComplete="off"
                                    prefix={<EditOutlined/>}
                                    onInput={(e) => this.handleInputChange(e, "setting")}
                                    />
                                </div>
                                <div className='form-box-user-input'>
                                    <Input
                                    type="text"
                                    value={this.state.test.settings.password}
                                    name="password"
                                    placeholder={i18n.t('test_input_password')}
                                    autoComplete="off"
                                    prefix={<EditOutlined/>}
                                    onInput={(e) => this.handleInputChange(e, "setting")}
                                    />
                                </div>
                                <div className='form-box-user-input'>
                                    <Input
                                    type="text"
                                    value={this.state.test.settings.waitForSearchFor}
                                    name="waitForSearchFor"
                                    placeholder={i18n.t('test_input_waitForSearchFor')}
                                    autoComplete="off"
                                    prefix={<EditOutlined/>}
                                    onInput={(e) => this.handleInputChange(e, "setting")}
                                    />
                                </div>
                                <h3 style={{textAlign:"center"}}>Static Tests</h3>
                                <br/>
                                <div className="custom-ant-selection">
                                    <Select
                                    mode="multiple"
                                    allowClear
                                    style={{ width: '100%' }}
                                    value={this.state.test.staticTests}
                                    placeholder="Please select"
                                    onChange={testType => this.handleRolesChange(testType)}
                                    >
                                    {this.state.staticTestTypes.map(testType => (
                                        <Select.Option key={testType} value={testType}>{testType}</Select.Option>
                                    ))}
                                    </Select>
                                </div>
                                <h3 style={{textAlign:"center"}}>Search - Result Tests</h3>
                                <br/>
                                {resultTests}
                                <Button
                                    className="custom-button"
                                    type="button"
                                    onClick={this.addPerson}
                                >
                                    Add Person
                                </Button>
                                <Button
                                    className="custom-button"
                                    type="button"
                                    onClick={this.state.pageMode === "update" ? this.updateTest : this.addTest}
                                >
                                    {this.state.pageMode === "update" ? i18n.t('update_test') : i18n.t('add_test')}
                                </Button>
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </>

        );

    }

}